@if (baseStore$ | async; as baseStore) {
<div class="udex-grid udex-mx-auto">
  <div class="block-container udex-py-56 udex-mx-auto">
    @if (showCustomerInfoComponent) {
    <dcp-customer-name (nameValidated)="nameValidated($event)"></dcp-customer-name>
    } @else if (!hideForm && cmsSelectionData) {
    <h2 class="heading__regular--xs udex-mb-20">
      {{ 'registration.label.companyDetails' | cxTranslate }}
    </h2>

    <p class="body--m text-grey udex-mb-20">{{ 'registration.label.selectionAlert' | cxTranslate }}</p>

    <div class="d-md-flex justify-content-md-between text-grey udex-mb-20">
      @if (cmsSelectionData.b2b && (!availableRegistrationFlows?.length || availableRegistrationFlows.includes('b2b')))
      {
      <udex-tile
        interactive
        href="javascript:void(0)"
        (click)="navigateToNextStep($any($event), cmsSelectionData.b2b.link)"
        aria-label="Continue"
        [attr.data-cy]="'organization-selection-type'"
        class="d-block udex-mb-40 udex-mb-md-0">
        <img
          src="/images/selection-component/b2b-flow-icon.svg"
          alt="Logo for Purchase as Company / Organization"
          class="udex-mb-16" />
        <p class="heading__medium--xs">{{ cmsSelectionData.b2b.title }}</p>
      </udex-tile>
      } @if (cmsSelectionData.b2i && (!availableRegistrationFlows?.length ||
      availableRegistrationFlows.includes('b2i'))) {
      <udex-tile
        interactive
        href="javascript:void(0)"
        (click)="
          isCcAllowedForCountry(baseStore) ? navigateToNextStep($any($event), cmsSelectionData.b2i.link) : openNoCcModal()
        "
        aria-label="Continue"
        [attr.data-cy]="'individual-selection-type'">
        <img
          src="/images/selection-component/b2i-flow-icon.svg"
          alt="Logo for Purchase as an individual"
          class="udex-mb-16" />
        <p class="heading__medium--xs">{{ cmsSelectionData.b2i.title }}</p>
      </udex-tile>
      }
    </div>

    <p class="body--xs text-blue-gray udex-mb-20">{{ 'registration.label.selectionTips' | cxTranslate }}</p>

    <udex-button size="Large" design="Secondary" (click)="backToPdp()">
      {{ 'registration.backButton' | cxTranslate }}
    </udex-button>
    }
  </div>
</div>
}
